<template>
    <footer class="footer-root w-full pt-16 pb-10 mt-24">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div class="max-w-3xl mx-auto">
                <div class="flex justify-center mb-6">
                    <a href="https://jeshubeauty.cl/" class="inline-block transition-transform duration-300 hover:-translate-y-0.5">
                        <img src="../assets/Logo-Completo-Negro.svg"
                             alt="Jeshu Beauty"
                             style="width: 78px; height: 78px;" />
                    </a>
                </div>

                <ul class="flex items-center justify-center flex-col gap-3 md:flex-row md:gap-10 py-5 mb-6 border-t border-b border-gris-cafe border-opacity-40">
                    <li><router-link to="/" class="nav-link footer-link">Inicio</router-link></li>
                    <li><router-link to="/about" class="nav-link footer-link">Quien soy</router-link></li>
                    <li><router-link to="/services" class="nav-link footer-link">Servicios</router-link></li>
                    <li><router-link to="/contact" class="nav-link footer-link">Contacto</router-link></li>
                    <li><router-link to="/galeria" class="nav-link footer-link">Trabajos</router-link></li>
                </ul>

                <div class="flex space-x-5 justify-center items-center mb-8">
                    <a href="https://www.instagram.com/jeshunails/" aria-label="Instagram" class="social-icon">
                        <img src="../assets/1161953_instagram_icon.png" alt="Instagram" />
                    </a>
                    <a href="https://www.linkedin.com/in/majmasferrer/" aria-label="LinkedIn" class="social-icon">
                        <img src="../assets/211909_linkedin_social_icon.png" alt="LinkedIn" />
                    </a>
                    <a href="https://www.youtube.com/@ItsJeshu" aria-label="YouTube" class="social-icon">
                        <img src="../assets/youtube.png" alt="YouTube" />
                    </a>
                </div>

                <span class="text-xs text-gray-500 text-center block tracking-wider">
                    © <a href="https://jeshubeauty.cl/" class="hover:text-purple-custom transition-colors">JeshuBeauty</a> {{ year }} · Todos los derechos reservados.
                </span>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>

<style scoped>
.footer-root {
    background: linear-gradient(180deg, rgba(244, 239, 249, 0) 0%, #f4eff9 60%, #efe6f5 100%);
    border-top: 1px solid rgba(184, 177, 189, 0.4);
}

.footer-link {
    color: #4b5563;
    font-size: 0.85rem;
    font-weight: 500;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    transition: color 0.3s ease;
}

.footer-link:hover {
    color: #734A91;
}

.social-icon {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    background: rgba(115, 74, 145, 0.10);
    transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
                background-color 0.35s ease,
                box-shadow 0.35s ease;
}

.social-icon img {
    width: 20px;
    height: 20px;
    transition: filter 0.3s ease;
}

.social-icon:hover {
    background: #734A91;
    transform: translateY(-3px);
    box-shadow: 0 10px 22px rgba(115, 74, 145, 0.28);
}

.social-icon:hover img {
    filter: brightness(0) invert(1);
}
</style>
